import type { PnrFormValues as FormValues } from "@jb-manage-trips/types/pnr";

export const sixCharAlphanumeric = /^[A-Za-z0-9]{6}$/;
export const thirteenDigitNumeric = /^\d{13}$/;
export const ticketNumberPattern = /^279\d{10}$/;
export const defaultValues: FormValues = {
  confirmationCode: "",
  dateofBirth: "",
  lastName: "",
};

const errorTextStyle: React.CSSProperties = {
  color: "#d50f0f",
  fontSize: "0.875rem",
  fontWeight: 600,
  marginTop: "0.25rem",
};

export function FieldError({ message }: { readonly message?: string }) {
  if (!message) {
    return null;
  }
  return <span style={errorTextStyle}>{message}</span>;
}
export function getStatusFromUnknown(error: unknown): number | undefined {
  if (error && typeof error === "object" && "status" in error) {
    const s = (error as { status?: unknown }).status;
    return typeof s === "number" ? s : undefined;
  }
  return undefined;
}
export function isTicketNumber(value: string): boolean {
  return ticketNumberPattern.test(value);
}
export function formatDobInput(value: string): string {
  const digitsOnly = value.replaceAll(/\D/g, "").slice(0, 8);

  if (digitsOnly.length <= 2) {
    return digitsOnly;
  }

  if (digitsOnly.length <= 4) {
    return `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2)}`;
  }

  return `${digitsOnly.slice(0, 2)}/${digitsOnly.slice(2, 4)}/${digitsOnly.slice(4)}`;
}
export function isValidDobString(value: string): boolean {
  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
    return false;
  }

  const [mmRaw, ddRaw, yyyyRaw] = value.split("/");
  const mm = Number(mmRaw);
  const dd = Number(ddRaw);
  const yyyy = Number(yyyyRaw);

  if (
    !Number.isInteger(mm) ||
    !Number.isInteger(dd) ||
    !Number.isInteger(yyyy)
  ) {
    return false;
  }

  if (yyyy < 1900) {
    return false;
  }

  const now = new Date();
  const candidate = new Date(yyyy, mm - 1, dd);

  const isRealDate =
    candidate.getFullYear() === yyyy &&
    candidate.getMonth() === mm - 1 &&
    candidate.getDate() === dd;

  if (!isRealDate) {
    return false;
  }

  return candidate <= now;
}
export function isValidConfirmationCodeKey(key: string): boolean {
  return /^[a-zA-Z0-9]|Backspace$/.test(key);
}
